import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getEffectiveTheme,
  useSessionLanguage,
  useSessionTheme,
} from '@context/SessionSettingsContext'

import { useGAEvents } from '@utils/callGAEvents'

import { mapAcuityLocale } from '@global/locale/Locale'

import { useScrollToTopOnRouteChange } from '@hooks/useScrollToTop'

import { AcquityHeader } from '../AcquityHeader'

declare const window: Window & { AcuityWidgets: any }

export const EconomicCalendar: React.FC = () => {
  useScrollToTopOnRouteChange()

  const { t } = useTranslation()
  const calendarWidgetRef = useRef(null)
  const locale = useSessionLanguage()
  const [mountTime] = useState(new Date())
  const theme = useSessionTheme()

  const effectiveTheme = getEffectiveTheme(theme)

  const { callGAEvents } = useGAEvents()

  useEffect(() => {
    callGAEvents().Tools.Links.economicCalendar()

    return () => {
      const timeSpent = Math.round((new Date().getTime() - mountTime.getTime()) / 1000)
      callGAEvents({ time_spent_in_seconds: timeSpent }).Tools.TimeSpent.economicCalendar()
    }
  }, [])

  useEffect(() => {
    window.AcuityWidgets.globals({
      apikey: 'f3eb0d37-bce0-40e2-bf70-1ce9fbfb8d90',
      locale: mapAcuityLocale(locale),
    })

    const widget = window.AcuityWidgets.CreateWidget(
      'CalendarTimeline',
      calendarWidgetRef.current,
      {
        utcOffset: new Date().getTimezoneOffset() * -1,
        settingId: effectiveTheme === 'light' ? 731 : 725,
      }
    )
    widget.mount()
  }, [locale, effectiveTheme])

  return (
    <>
      <AcquityHeader
        title={t('Economic Calendar')}
        description={t(
          'Economic data releases shape daily market trends. Traders rely on their economic calendars to track key reports, gaining insights into emerging opportunities and managing risks amid market volatility. From GDP growth rates and employment figures to interest rate decisions and inflation data, each release provides crucial information that can influence trading strategies and portfolio adjustments.'
        )}
      />
      <div style={{ zIndex: 1 }} id='calendar-timeline' ref={calendarWidgetRef} />
    </>
  )
}
